'use client';

import { usePathname } from 'next/navigation';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useBonanzaPromo } from '../../hooks';
import { PromoSnackbar } from '../PromoSnackbar';
import { useCommonStore } from '@/store';

import { ScBonanzaPromoSnackbarContent } from './styled';

export const BonanzaPromoSnackbar = () => {
  const { t } = useTranslation();
  const { isBonusIssued, handleAcknowledgeBonus, handleNavigateToBonanza } =
    useBonanzaPromo();
  const bonanzaReward = useCommonStore.use.bonanzaReward();
  const bonanzaPromoMenuData = useCommonStore.use.bonanzaPromoMenuData();
  const pathname = usePathname();

  const character = useMemo(() => {
    return bonanzaPromoMenuData?.menu.charactersByStatus.find(
      ({ promoStatus }) => promoStatus === 'LEVEL_3'
    );
  }, [bonanzaPromoMenuData]);

  if (!isBonusIssued || !character || pathname.includes('bonanza')) return;

  return (
    <PromoSnackbar
      icon={character.image.url}
      content={
        <ScBonanzaPromoSnackbarContent>
          <a onClick={handleNavigateToBonanza}>Bonanza</a>
          <span>{t('bonanzaPromo.bonusReceived').toLowerCase()}:</span>
          <strong>{bonanzaReward}</strong>
        </ScBonanzaPromoSnackbarContent>
      }
      onClose={handleAcknowledgeBonus}
    />
  );
};
